import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamsUserResult } from '../../../shared/models/generated/ziroModels';

export enum TeamsUserSearchScope {
  CALL_QUEUE_MANAGEMENT = 'call-queue-management',
  TEAMS_USER_MANAGEMENT = 'teams-user-management',
}

@Injectable({ providedIn: 'root' })
export class MicrosoftTeamsUserSearchResource {
  private http = inject(HttpClient);

  search(
    tenantId: string,
    scope: TeamsUserSearchScope,
    query: string,
    enterpriseVoiceEnabled?: boolean,
    limit = 250,
    accountType = 'ALL',
  ): Observable<MicrosoftTeamsUserResult[]> {
    let params = `q=${encodeURIComponent(query)}&accountType=${accountType}`;
    if (limit != null) {
      params += `&limit=${limit}`;
    }
    if (enterpriseVoiceEnabled != null) {
      params += `&enterpriseVoiceEnabled=${enterpriseVoiceEnabled}`;
    }
    return this.http.get<MicrosoftTeamsUserResult[]>(
      `/services/microsoft/${scope}/tenants/${tenantId}/teams-users/search?${params}`,
    );
  }

  searchByUserPrincipalName(
    tenantId: string,
    scope: TeamsUserSearchScope,
    userPrincipalName: string,
  ): Observable<MicrosoftTeamsUserResult[]> {
    return this.http.get<MicrosoftTeamsUserResult[]>(
      `/services/microsoft/${scope}/tenants/${tenantId}/teams-users/search?userPrincipalName=${encodeURIComponent(userPrincipalName)}&limit=1`,
    );
  }
}
